import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import {
  EMPTY_TO_MANY,
  EMPTY_TO_ONE,
  linkageFromResource,
} from '@opallabs/json-api'
import { boardUserSettingResourceFactory } from './board_user_setting'
import { userResourceFactory } from './user'
import { workspaceResourceFactory } from './workspace'

type BoardResourceV3 = OpalApiComponent<'V3', 'board'>
export const boardResourceFactory: Factory<BoardResourceV3> =
  Factory.define<BoardResourceV3>(({ params, afterBuild, sequence }) => {
    afterBuild((board) => {
      /**
       * Set board_user_setting in afterBuild to prevent circular reference
       */
      if (!params.relationships?.board_user_setting) {
        const boardUserSetting = boardUserSettingResourceFactory.build({
          relationships: {
            board: linkageFromResource(board),
          },
        })
        board.relationships.board_user_setting =
          linkageFromResource(boardUserSetting)
      }
    })

    return {
      id: uuidV4(),
      type: 'board',
      attributes: {
        created_at: new Date().toISOString(),
        description: null,
        is_public: false,
        is_archived: false,
        title: `Mock Board ${sequence}`,
        updated_at: new Date().toISOString(),
      },
      relationships: {
        asset_reference: EMPTY_TO_ONE,
        board_collaborators: EMPTY_TO_MANY,
        board_columns: EMPTY_TO_MANY,
        board_objects: EMPTY_TO_MANY,
        board_user_setting: {
          data: { id: 'stubbed_until_afterBuild', type: 'board_user_setting' },
        },
        collaborators: EMPTY_TO_MANY,
        created_by_user: linkageFromResource(userResourceFactory.build()),
        default_story: EMPTY_TO_ONE,
        object_collections: EMPTY_TO_MANY,
        workspace: linkageFromResource(workspaceResourceFactory.build()),
      },
    } satisfies BoardResourceV3
  })
